import mixins from 'vue-typed-mixins'
import globalMixin from '../globalMixin'
import routeMixin from '@/router/routeMixin'
import { Evenement } from '@/domain/Evenement'
import { EnumPermission } from '@/domain/permission'
import Openable from '@/global/viewmodels/openable'

export default mixins(routeMixin, globalMixin).extend({
    data: function() {
        return {
            evenements: [] as Array<Evenement>,
            dialog: new Openable(),
            evenement: null as null | Evenement,
            file: null as null | File,
            dialogImage: new Openable(),
        }
    },
    methods: {
        ajouterEvenement() {
            this.evenement = new Evenement()
            this.dialog.open()
        },
        ajouterFichier() {
            if (!this.file) return
            if (!this.evenement) return

            const formData = new FormData()
            formData.append('file', this.file, this.file.name)
            formData.append('Id', this.evenement.id.toString())

            this.$loader.go()
            this.$http
                .api(`evenement/file`)
                .post(formData)
                .then(x => {
                    this.file = null
                    this.evenement = null
                    this.dialogImage.close()
                    this.$swal.toast.success()
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        loadEvenements() {
            this.$loader.go()

            return this.$http
                .api(`evenement/all`)
                .get()
                .then(x => {
                    this.evenements = x.data
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        deleteEvenement(id: number) {
            this.$swal.confirm.delete().then(a => {
                if (!a.isConfirmed) return

                this.$http
                    .api(`evenement`)
                    .deleteWithData(id)
                    .then(x => {
                        this.$swal.toast.success()
                        this.loadEvenements()
                    })
                    .catch(x => this.$swal.toast.errorApi(x))
                    .finally(() => this.$loader.stop())
            })
        },
        save() {
            return this.$http
                .api(`evenement`)
                .post(this.evenement)
                .then(x => {
                    this.evenement = null
                    this.dialog.close()
                    this.$swal.toast.success()
                    this.loadEvenements()
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        }
    },
    computed: {
        canWrite: function(): boolean {
            return this.$database.account.permissions.indexOf(EnumPermission.Evenement_Write) !== -1
        }
    },
    mounted() {
        this.loadEvenements()
    }
})
